"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _Button = require("../Button/Button");
var _ResultModalModule = _interopRequireDefault(require("./ResultModal.module.css"));
var _modal = require("../assets/icons/modal");
var _excluded = ["onCancel", "message"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ResultModal = function ResultModal(_ref) {
  var onCancel = _ref.onCancel,
    message = _ref.message,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, _extends({
    contentClassName: _ResultModalModule.default.container,
    onHide: onCancel
  }, props), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    closeButton: true,
    closeVariant: 'white',
    className: _ResultModalModule.default.header
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: _ResultModalModule.default.body
  }, message), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, {
    className: _ResultModalModule.default.footer,
    style: {
      '--divider': "url(".concat(_modal.Divider, ")")
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'secondary',
    onClick: onCancel
  }, "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0")));
};
exports.ResultModal = ResultModal;
ResultModal.propTypes = {
  show: _propTypes.default.bool,
  centered: _propTypes.default.bool,
  message: _propTypes.default.string
};
ResultModal.defaultProps = {
  show: true,
  centered: true,
  message: 'არასწორი პარამეტრები'
};